import React, { useEffect, useState } from 'react';
import * as S from './styles';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { MdArrowBack } from 'react-icons/md';
import { FaQuestionCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import secureStorage from '../../utils/SecureStorage';
import ModalCadastroEstabelecimento from './ModalCadastroEstabelecimento';
import useBuscaEstabelecimento from '../../services/Estabelecimento/useBuscaEstabelecimento';
import Del from '../../services/Estabelecimento/del';
import EstabelecimentoService from '../../services/Estabelecimento/EstabelecimentoService';

const EstabelecimentoLista = () => {
  const [filtro, setFiltro] = useState('');
  const [selecionados, setSelecionados] = useState([]);
  const [agruparPor, setAgruparPor] = useState('cidade');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] = useState(null);
  const navigate = useNavigate();
  const [mostrarAjuda, setMostrarAjuda] = useState(false);

  // Hook de busca igual ao código antigo
  const { searchResults, loadregistros } = useBuscaEstabelecimento([]);

  useEffect(() => {
    const idrede = secureStorage.getItem('id_r');
    if (idrede) {
      loadregistros(idrede);
    }
  }, []);

  const deletarSelecionados = async () => {
    for (const id of selecionados) {
      const idString = typeof id === 'object' && id.$oid ? id.$oid : id;
      try {
        await Del.excluirEstabelecimento(idString);
      } catch (error) {
        console.error('Erro ao excluir:', error);
      }
    }
    setSelecionados([]);
    // Recarregar após deleção
    const idrede = secureStorage.getItem('id_r');
    if (idrede) {
      loadregistros(idrede);
    }
  };

  const toggleSelecionado = (id) => {
    const idString = typeof id === 'object' && id.$oid ? id.$oid : id;
    setSelecionados((prev) =>
      prev.includes(idString) ? prev.filter((pid) => pid !== idString) : [...prev, idString]
    );
  };

  const abrirModalEdicao = (estabelecimento) => {
    setEstabelecimentoSelecionado(estabelecimento);
    setIsModalOpen(true);
  };

  const fecharModal = () => {
    setEstabelecimentoSelecionado(null);
    setIsModalOpen(false);
    // Recarregar após cadastro/edição
    const idrede = secureStorage.getItem('id_r');
    if (idrede) {
      loadregistros(idrede);
    }
  };

  // Usar searchResults como fonte dos dados
  const estabelecimentosFiltrados = searchResults.filter((e) =>
    e.nome_fantasia?.toLowerCase().includes(filtro.toLowerCase())
  );

  const estabelecimentosAgrupados = estabelecimentosFiltrados.reduce((acc, atual) => {
    let chave;
    if (agruparPor === 'cidade') {
      chave = atual.endereco?.cidade || 'Sem cidade';
    } else if (agruparPor === 'nome') {
      const nome = atual.nome_fantasia || 'Sem nome';
      chave = nome.split(' ')[0].toUpperCase();
    }
    if (!acc[chave]) acc[chave] = [];
    acc[chave].push(atual);
    return acc;
  }, {});

  return (
    <>
      <Header />
      <div style={{ position: 'fixed', top: 80, right: 20, zIndex: 1000, cursor: 'pointer' }}>
        <FaQuestionCircle
          size={28}
          color="#cf0505"
          title="Ajuda em vídeo"
          onClick={() => setMostrarAjuda(true)}
        />
      </div>
      {/* Exibir modal de ajuda se necessário */}
      <S.BackButton onClick={() => navigate('/home')}>
        <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
        Voltar
      </S.BackButton>
      <S.Container style={{ paddingBottom: '100px' }}>
        <div style={{ textAlign: 'center', margin: '40px 0 24px' }}>
          <S.Title>Cadastro de Estabelecimento</S.Title>
        </div>
        <S.TopActions>
          <button onClick={() => setAgruparPor('cidade')} disabled={agruparPor === 'cidade'}>
            Agrupar por Cidade
          </button>
          <button onClick={() => setAgruparPor('nome')} disabled={agruparPor === 'nome'}>
            Agrupar por Nome
          </button>
          <button onClick={() => {
            setEstabelecimentoSelecionado(null);
            setIsModalOpen(true);
          }}>
            Cadastrar Novo
          </button>
          <button onClick={deletarSelecionados} disabled={selecionados.length === 0}>
            Deletar Selecionados
          </button>
        </S.TopActions>
        <S.ActionInputWrapper>
          <input
            type="text"
            placeholder="Buscar por nome fantasia..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </S.ActionInputWrapper>
        {Object.keys(estabelecimentosAgrupados).length > 0 ? (
          <S.ScrollableTableArea>
            {Object.entries(estabelecimentosAgrupados).map(([chave, registros]) => (
              <div key={chave} style={{ marginBottom: '30px' }}>
                <h3 style={{ margin: '20px 0 10px' }}>{chave}</h3>
                <S.StyledTable>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Nome Fantasia</th>
                      <th>Cnpj</th>
                      <th>Cidade</th>
                      <th>Bairro</th>
                      <th>Endereço</th>
                      <th>Contato</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros.map((e) => {
                      const hasPolygon = e.endereco?.poligonoEstabelecimento?.length > 0;
                      const rowStyle = !hasPolygon ? { backgroundColor: 'rgba(207, 5, 5, 0.1)' } : {};
                      const rowTitle = !hasPolygon ? 'Este estabelecimento não possui polígono de mapeamento.' : '';

                      return (
                        <tr key={e._id?.$oid || e._id} style={rowStyle} title={rowTitle}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selecionados.includes(e._id?.$oid || e._id)}
                              onChange={() => toggleSelecionado(e._id?.$oid || e._id)}
                            />
                          </td>
                          <td>{e.nome_fantasia || '---'}</td>
                          <td>{EstabelecimentoService.applyCpfCnpjMask(e.cpf_cnpj) || '---'}</td>
                          <td>{e.endereco?.cidade || '---'}</td>
                          <td>{e.endereco?.bairro || '---'}</td>
                          <td>
                            {e.endereco?.rua}, {e.endereco?.numero}
                          </td>
                          <td>{e.contato?.celular || e.contato?.telefone_fixo || '---'}</td>
                          <td>
                            <S.EditButton onClick={() => abrirModalEdicao(e)}>
                              Editar
                            </S.EditButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </S.StyledTable>
              </div>
            ))}
          </S.ScrollableTableArea>
        ) : (
          <p style={{ textAlign: 'center', marginTop: '20px' }}>Nenhum estabelecimento encontrado.</p>
        )}
      </S.Container>
      {isModalOpen && (
        <ModalCadastroEstabelecimento
          isOpen={isModalOpen}
          onClose={fecharModal}
          estabelecimentoSelecionado={estabelecimentoSelecionado}
          atualizarLista={() => {
            const idrede = secureStorage.getItem('id_r');
            if (idrede) {
              loadregistros(idrede);
            }
          }}
        />
      )}
      <Footer />
    </>
  );
};

export default EstabelecimentoLista;
